import { render } from "./insertPassword.vue?vue&type=template&id=721c11c2"
import script from "./insertPassword.vue?vue&type=script&lang=js"
export * from "./insertPassword.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__